import { computed } from 'vue';
import { useQueryV2 } from '@libs/use';
import { MaybeRef } from '@vueuse/core';

import * as API from '../requests';
import { SYMBOL_QUERY_KEYS } from '../constants';

export default function useGetClassificationSymbols(
  { immediate }: { immediate: MaybeRef<boolean> } = { immediate: false }
) {
  const {
    result,
    execute: getClassificationSymbols,
    isPending: isLoadingClassificationSymbols,
    isSuccess: isSuccessLoadingClassificationSymbols,
    isError: isErrorLoadingClassificationSymbols,
  } = useQueryV2(API.getClassificationSymbols, {
    key: SYMBOL_QUERY_KEYS.symbolClassification,
    immediate,
    staleTime: 1000 * 60 * 60 * 5, // 5h
    cacheTime: 1000 * 60 * 60 * 96, // 4d
  });

  const classificationSymbols = computed(() => result.value?.data?.items || []);

  const sortClassificationSymbols = computed(() =>
    classificationSymbols.value.sort((a, b) => {
      if (a.rank == null) return 1;
      if (b.rank == null) return -1;
      return a.rank - b.rank;
    })
  );

  return {
    classificationSymbols,
    sortClassificationSymbols,
    getClassificationSymbols,
    isLoadingClassificationSymbols,
    isSuccessLoadingClassificationSymbols,
    isErrorLoadingClassificationSymbols,
  };
}
